var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.path !== '/cerdetail')?_c('Top'):_vm._e(),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1),(_vm.$route.path !== '/cerdetail')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }